/** One queued scroll belongs to the timeline that requested it. */
export function createTimelineScrollFrame() {
  let frame: number | null = null;
  let generation = 0;
  const cancel = () => {
    generation += 1;
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null;
  };
  return {
    cancel,
    schedule(scroll: () => void) {
      cancel();
      const requestedGeneration = generation;
      frame = requestAnimationFrame(() => {
        if (generation !== requestedGeneration) return;
        frame = null;
        scroll();
      });
    },
  };
}
